import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setAnswer } from '../../actions/questionActions';

const Texto = ({ title, idPregunta }) => {
  const dispatch = useDispatch();
  const answers = useSelector(state => state.question.answers);
  const currentAnswer = answers[idPregunta] || {};
  const reduxValue = currentAnswer.answer || '';
  const answerId = currentAnswer.answerId;

  // Estado local para el valor del textarea
  const [valor, setValor] = useState(reduxValue);

  // Solo sincroniza cuando cambia la pregunta
  useEffect(() => {
    setValor(reduxValue);
  }, [idPregunta]);

  const handleTextChange = (textValue) => {
    setValor(textValue);
    dispatch(setAnswer(idPregunta, textValue, false, answerId));
  };

  return (
    <div>
      <Form.Group className="tipo-de-credencial-parent mb-3">
        <Form.Label className='nombre'>{title}</Form.Label>
        <Form.Control 
          as="textarea" 
          rows={3} 
          placeholder="Ingresá tu respuesta" 
          required 
          value={valor} 
          onChange={(e) => handleTextChange(e.target.value)} 
        />
      </Form.Group>
    </div>
  );
};

export default Texto;
